import { Box } from '@factorialco/deprecated-design-system'

import { useInhousePayroll } from 'modules/payroll_bundle/hooks/useInhousePayroll'

import Stats from './_Stats'

const IncidencesPageHeader = () => {
  const { hasInhousePayroll } = useInhousePayroll()

  return (
    <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
      <Stats inHousePayroll={hasInhousePayroll} />
    </Box>
  )
}

export default IncidencesPageHeader
